<template>
  <nav-bar title="订单列表" />
  <Content :bottom="$store.state.roleInfo.roleId === 'c' ? 0 : 76">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <customer-info v-if="!userId" />
    <div class="customer-info" v-else>
      <span>{{ companyInfo.companyName }}</span>
      <span>{{ companyInfo.userName }}</span>
    </div>
    <order-list-item :list="list" @detail="handleDetailClick" />
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="getList"
    />
  </Content>
  <div
    class="btn-conatiner van-hairline--top"
    v-if="$store.state.roleInfo.roleId === 'c'"
  >
    <van-button
      to="/addOrder"
      block
      type="primary"
      :disabled="$store.state.roleInfo.roleId !== 'c'"
      native-type="button"
    >
      新增订单
    </van-button>
  </div>
</template>

<script>
import { getUserOrderList } from '@/api/order'
import { useRouter } from 'vue-router'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useGetData } from '@/hooks/useGetData'
import { bGlmCustomer } from '@/api/user'
import { useStore } from 'vuex'
import { ref, computed } from 'vue'
export default {
  name: 'OrderList',
  props: ['userId'],
  setup(props) {
    const store = useStore()
    const userId =
      props.userId || computed(() => store.state.customer.userId).value
    const router = useRouter()
    const data = useLoadingMore(getUserOrderList)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.gsStatus = 1
      pageParams.page = 1
      pageParams.pageNum = 15
      pageParams.orderStatus = ''
      pageParams.user_id = userId
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init()
    const companyInfo = ref('')
    const getCompanyInfo = useGetData(bGlmCustomer, data => {
      companyInfo.value = data
    })
    getCompanyInfo(userId)
    const handleDetailClick = ({ orderId }) => {
      router.push(`/orderInfo/${orderId}`)
    }

    return {
      ...data,
      handleDetailClick,
      companyInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
.customer-info {
  display: flex;
  padding: 16px;
  font-size: 14px;
  color: #333;
  font-weight: 600;
  justify-content: space-between;
  background-color: #fff;
}
</style>
